import { WallBack, WallFront, WallShade, WallSheen } from './wall.art';
import { wallRegions } from './wall.geometry';
import type { SceneDefinition } from './types';

/** Wall: a full-height stone feature wall with a lit niche, seams as an option. */
export const wallScene: SceneDefinition = {
  id: 'wall',
  surface: 'wall',
  regions: wallRegions,
  Back: WallBack,
  Shade: WallShade,
  Sheen: WallSheen,
  Front: WallFront,
  seams: true,
  photo: null,
};
